import { Box, Stack } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import EditIcon from '@mui/icons-material/Edit';
import { useSelector } from 'react-redux';
import fallBackImage from 'assets/images/placeholder_artwork02.jpg';
import { isReleasable } from 'services/helpers/distribution';
import { Release } from 'services/api/entities';
import { AudioPlayerButton } from 'components';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { selectSong } from 'services/store/newSongs/selectors';
import { useReleaseNavigation } from 'services/hooks/distribution';
import ReleaseStatusChip from './ReleaseStatusChip';
import DeleteReleaseButton from './DeleteReleaseButton';
import {
  StyledCard,
  StyledCardMedia,
  StyledCardMediaInner,
  StyledCoverArt,
  StyledPlayerWrapper,
  StyledCardActions,
  StyledTitle,
  StyledArtistName,
  StyledActionIcon,
} from './styled';

type PropsType = {
  release: Release;
};

const ReleaseTile = ({ release }: PropsType) => {
  const { status, title, artistName, coverArtPath, songs } = release;
  const navigateToReleaseFlow = useReleaseNavigation();

  const song = useSelector(selectSong(songs[0].id));

  const handleEditClick = () => {
    navigateToReleaseFlow(release.id);
  };

  return (
    <StyledCard>
      <StyledCardMedia>
        <StyledCardMediaInner>
          <StyledCoverArt src={coverArtPath || fallBackImage} alt="cover art" />
          <StyledPlayerWrapper>
            <AudioPlayerButton
              song={song}
              location={AnalyticsEventLocation.RELEASE_TILE}
            />
          </StyledPlayerWrapper>
        </StyledCardMediaInner>
      </StyledCardMedia>
      <Box>
        <CardContent>
          <StyledTitle noWrap>{title || '-'}</StyledTitle>
          <StyledArtistName noWrap>{artistName || '-'}</StyledArtistName>
        </CardContent>
      </Box>
      <StyledCardActions>
        <ReleaseStatusChip releaseStatus={status} />
        {isReleasable(status) && (
          <Stack direction="row" spacing={2}>
            <StyledActionIcon component={EditIcon} onClick={handleEditClick} />
            <DeleteReleaseButton release={release} />
          </Stack>
        )}
      </StyledCardActions>
    </StyledCard>
  );
};

export default ReleaseTile;
